define(function(require, exports, module) {
    'use strict';

    module.exports = {

        /**
         * @param {object} options
         **/
        notify: function(options) {
            window.Playtech.API.popup.showPopup('login', {
                ...options.data,
                ...options.data?.data
            });
        }
    };
});
